// Sidebar nav verisi -- AppShell dışına çıkarıldı (component saf render kalır).
// Bölümler + rotalar plan BÖLÜM 4 tablosuyla birebir eşleşir.
export interface NavItem {
  path: string;
  labelKey: string;
  end?: boolean;
}

export interface NavSection {
  sectionKey: string;
  items: NavItem[];
}

export const navConfig: NavSection[] = [
  {
    sectionKey: 'nav.sections.general',
    items: [
      { path: '/', labelKey: 'nav.dashboard', end: true },
      { path: '/analytics', labelKey: 'nav.analytics' },
    ],
  },
  {
    sectionKey: 'nav.sections.users',
    items: [
      { path: '/users', labelKey: 'nav.users' },
      { path: '/premium', labelKey: 'nav.premium' },
    ],
  },
  {
    sectionKey: 'nav.sections.content',
    items: [
      { path: '/playlists', labelKey: 'nav.playlists' },
      { path: '/devices', labelKey: 'nav.devices' },
      { path: '/web-cast', labelKey: 'nav.webCast' },
    ],
  },
  {
    sectionKey: 'nav.sections.system',
    items: [
      { path: '/feedback', labelKey: 'nav.feedback' },
      { path: '/errors', labelKey: 'nav.errors' },
      { path: '/admins', labelKey: 'nav.admins' },
      { path: '/audit-log', labelKey: 'nav.auditLog' },
      { path: '/settings', labelKey: 'nav.settings' },
    ],
  },
];
